<template>
  <div class="subscribe">
    <common-title titleName="申请提现" :isAPPShow="true"></common-title>
    <div class="subscribe__top" v-if="!(this.$root.miniprogram)"></div>
    <div class="subscribe__cash">
      <span class="label">提现金额(元)</span>
      <span class="num">{{ formatMoney(accountInfo.withdrawAmount) }}</span>
    </div>

    <div class="infoFrom">
      <div class="title">收款账户信息</div>
      <van-field required label="姓名" v-model="recipientName" placeholder="请输入姓名" maxlength="16" />
      <p>请填写支付宝账户实名认证的姓名</p>
      <van-field required label="支付宝账号" v-model.trim="alipayAccount" placeholder="请输入支付宝账号" maxlength="32" />
      <van-field required label="身份证号码" v-model.trim="idCardNumber" placeholder="请输入身份证号" maxlength="18" />
      <p>请填写支付宝实名认证的身份证号码，必须与姓名、支付宝账户是同一人</p>
    </div>
    <div class="tips">注：请按要求检查收款账户信息，为避免打款失败，身份证号、姓名、支付宝账户必须是同一人。</div>
    <div class="btn-submit" @click="submit">
      <span>立即提现</span>
    </div>
    <van-overlay :show="showConfirm" @click="showConfirm = false">
      <div class="wrapper wrapper_tip" @click.stop>
        <div class="wrapper__title">
          <span></span>
          <span>确认提现</span>
          <img @click="showConfirm = false"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_close.png"
            alt="">
        </div>
        <div class="wrapper__content">
          <p>请核对收款账户信息，确认信息无误后再提交</p>
          <div class="info-item"><span>姓名：</span><span>{{ recipientName }}</span></div>
          <div class="info-item"><span>支付宝账户：</span><span>{{ alipayAccount }}</span></div>
          <div class="info-item"><span>身份证号码：</span><span>{{ idCardNumber }}</span></div>
          <div class="btn-comfirm">
            <div @click="showConfirm = false">返回修改</div>
            <span></span>
            <div @click="onConfirm">确认提交</div>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  reqUserAccount,
  reqWithdraw,
} from '@/api/invitationCommission';

import CommonTitle from '@/components/header/CommonTitle.vue';
import { formatMoney } from '@/utils/tools';

export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      accountInfo: {},
      recipientName: '',
      alipayAccount: '',
      idCardNumber: '',
      showConfirm: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  beforeRouteEnter(to, from, next) {
    const token = window.localStorage.getItem('accessToken');
    if (token) {
      next();
    } else {
      next((vm) => {
        vm.$root.openLogin('/invitation/subscribe');
      });
    }
  },
  mounted() {
    document.title = '申请提现';
    this.initPage();
  },
  methods: {
    formatMoney,
    initPage() {
      if (!this.userInfo?.id) return;
      this.getUserAccount();
    },
    // 查看我的账户信息
    getUserAccount() {
      reqUserAccount().then((res) => {
        this.accountInfo = res;
      });
    },
    submit() {
      if (this.accountInfo.withdrawAmount === 0) {
        this.$toast('金额为0，不可提现');
      } else if (this.recipientName === undefined || this.recipientName === '') {
        this.$toast('请填写收款人姓名');
      } else if (this.recipientName.length > 16) {
        this.$toast('收款人姓名不超过16个字');
      } else if (this.alipayAccount === undefined || this.alipayAccount === '') {
        this.$toast('请填写支付宝账号');
      } else if (this.alipayAccount.length > 32) {
        this.$toast('支付宝账号不超过32个字');
      } else if (this.idCardNumber === undefined || this.idCardNumber === '') {
        this.$toast('请输入身份证号');
      } else if (this.idCardNumber.length !== 15 && this.idCardNumber.length !== 18) {
        this.$toast('请输入正确的身份证号');
      } else {
        this.showConfirm = true;
      }
    },
    onConfirm() {
      const params = {
        alipayAccount: this.alipayAccount,
        amount: this.accountInfo.withdrawAmount,
        idCardNumber: this.idCardNumber,
        recipientName: this.recipientName,
      };
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0,
      });
      reqWithdraw(params).then((res) => {
        this.$toast.clear();
        if (res.code !== 0) {
          this.$toast({
            message: res.msg,
            position: 'middle',
            duration: 1500,
          });
          // 账户佣金与实际佣金不匹配
          if (res.code === 9503) {
            setTimeout(() => {
              this.getUserAccount();
            }, 1500);
          }
        } else {
          this.$toast({
            message: '提交成功，将在30天内转账至您的支付宝账户，请注意查收',
            position: 'middle',
            duration: 1500,
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        }
      });
    },
  },

  watch: {
    userInfo: {
      deep: true,
      handler(val) {
        if (!val?.id) {
          // 区分App和h5
          if (!(this.$root.$data.isApp || this.$root.$data.miniprogram)) {
            this.$routerr.push({
              path: '/registrationLogin',
              query: { redirect: '/invitation/subscribe' },
            });
          }
        } else {
          this.initPage();
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.subscribe {
  background: #F7F8FC;

  &__top {
    padding-top: 100px;
  }

  &__cash {
    display: flex;
    align-items: center;
    width: 678px;
    height: 123px;
    margin: 36px auto 0;
    padding-left: 29px;
    background: #FFF;
    border-radius: 14px;

    .label {
      height: 36px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      font-style: normal;
      line-height: 36px;
      text-align: left;
    }

    .num {
      display: inline-block;
      height: 40px;
      margin-left: 29px;
      color: #333;
      font-weight: 600;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: left;
    }
  }

  .infoFrom {
    width: 678px;
    margin: 22px auto 0;
    padding: 36px 29px;
    background: #FFF;
    border-radius: 14px;

    .title {
      width: fit-content;
      height: 40px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: left;
    }

    p {
      width: 620px;
      margin-top: 14px;
      color: #999;
      font-weight: 400;
      font-size: 22px;
      font-style: normal;
      line-height: 31px;
      text-align: left;
    }

    ::v-deep .van-cell {
      padding: 0;

      &:nth-child(2) {
        &::before {
          position: absolute;
          top: 50%;
          left: 32px;
          color: #ee0a24;
          font-size: 14px;
          transform: translateY(-50%);
          content: '*';
        }

        margin-top: 0.32rem;
      }

      &:nth-child(4) {
        &::before {
          position: absolute;
          top: 50%;
          left: 75px;
          color: #ee0a24;
          font-size: 14px;
          transform: translateY(-50%);
          content: '*';
        }

        margin-top: 0.48rem;
      }

      &:nth-child(5) {
        &::before {
          position: absolute;
          top: 50%;
          left: 75px;
          color: #ee0a24;
          font-size: 14px;
          transform: translateY(-50%);
          content: '*';
        }

        margin-top: 0.29333rem;
      }

      &::after {
        border-bottom: none;
      }

      .van-cell__title {
        display: flex;
        align-items: center;
      }

      .van-field__body {
        height: 36px;
        font-size:0.33333rem;
        background: #F5F6F7;
        border-radius: 5px;

        .van-field__control {
          font-size: 0.33333rem;
          text-indent: 10px;

          &::placeholder {
            color: #999;
            font-size:0.33333rem;
          }
        }
      }
    }
  }

  .tips {
    width: 678px;
    height: 72px;
    margin: 29px auto 0;
    color: #F44;
    font-weight: 400;
    font-size: 25px;
    font-style: normal;
    line-height: 36px;
    text-align: left;
  }

  .btn-submit {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 750px;
    height: 167px;
    background: #FFF;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);

    span {
      width: 678px;
      height: 80px;
      margin-top: 22px;
      color: #FFF;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 80px;
      text-align: center;
      background: #FF7F41;
      border-radius: 49px;
    }
  }

  ::v-deep .van-overlay {
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    width: 634px;
    height: 259px;
    padding: 31px 33px 0;
    background: #FFF;
    border-radius: 36px;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: center;

      span {
        font-weight: 500;
        &:nth-child(1) {
          width: 29px;
          height: 29px;
        }
      }

      & img {
        display: inline-block;
        width: 29px;
        height: 29px;
      }
    }

    &__content {
      height: 43px;
      margin-top: 29px;
      color: #333;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 43px;
      text-align: center;
    }

    &_tip {
      height: auto;
      padding: 31px 33px 0;

      .wrapper__content {
        height: auto;
        text-align: left;

        p {
          width: 569px;
          height: 43px;
          margin-bottom: 58px;
          color: #999;
          font-weight: 400;
          font-size: 25px;
          font-style: normal;
          line-height: 43px;
          text-align: justify;
        }

        .info-item {
          width: 569px;
          margin-bottom: 29px;
          color: #333;
          font-weight: 400;
          font-size: 29px;
          font-style: normal;
          line-height: 43px;
          text-align: left;
        }

        .btn-comfirm {
          display: flex;
          width: 634px;
          height: 92px;
          margin-top: 72px;
          margin-left: -33px;
          border-top: 2px solid #EFEFEF;

          div {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            color: #999;
            font-weight: 400;
            font-size: 29px;
            font-style: normal;
            line-height: 40px;
            text-align: left;

            &:last-child {
              color: #FF7F41;
            }
          }

          span {
            width: 2px;
            height: 100%;
            height: 91px;
            background: #EFEFEF;
          }
        }
      }
    }
  }
}
</style>
